import React from 'react';
import PropTypes from 'prop-types';
import {propTypes, withFormsy} from "formsy-react";
import {
    FormGroup,
    Input,
    InputGroup,
    Label,
    FormFeedback,
    InputGroupButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import {FormattedMessage} from "react-intl";

class PhoneInputFormGroup extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        countryOptions: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
            }).isRequired,
        ).isRequired,
        ...propTypes
    };

    static defaultProps = {
        disabled: false
    };

    componentWillMount() {
        const value = this.props.getValue() || '';
        let countryCode = this.props.countryOptions[0];
        for (const option of this.props.countryOptions) {
            if (value.startsWith(option.value)) {
                countryCode = option;
                break;
            }
        }

        const number = value.substr(countryCode.value.length);

        this.setState({
            number,
            countryCode,
            dropdownOpen: false,
        });
    }

    changeNumber(event) {
        const number = event.target.value;
        this.props.setValue(this.state.countryCode.value + number);
        this.setState({
            number
        });
    }

    changeCountryCode(countryCode) {
        this.props.setValue(countryCode.value + this.state.number);
        this.setState({
            countryCode
        });
    }

    render() {
        const {name, id, label, showError, isPristine, showRequired, isRequired, getErrorMessage, placeholder, disabled, countryOptions} = this.props;
        const valid = isPristine() ? undefined : (!showError() && !showRequired());

        return (
            <FormGroup>
                {typeof label !== "undefined" &&
                <Label className={isRequired() ? 'required' : ''} for={id}>
                    {label}
                </Label>
                }

                <InputGroup>
                    <InputGroupButtonDropdown addonType="prepend" className="input-group-append" isOpen={this.state.dropdownOpen}
                                              toggle={() => this.setState({dropdownOpen: !this.state.dropdownOpen})}>
                        <DropdownToggle color="primary" caret disabled={disabled || countryOptions.length < 2}>
                            {this.state.countryCode.name}
                        </DropdownToggle>
                        <DropdownMenu>
                            {countryOptions.map((option, idx) => (
                                <DropdownItem key={"phone-option-" + idx} onClick={() => ::this.changeCountryCode(option)}>
                                    {option.name}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </InputGroupButtonDropdown>
                    <Input disabled={disabled} placeholder={placeholder} valid={valid} invalid={!isPristine() && !valid}
                           name={name} id={id} type="text" value={this.state.number} onChange={::this.changeNumber}/>

                    {!isPristine() && showRequired() &&
                    <FormFeedback>
                        <FormattedMessage id="form.error.required" defaultMessage="Field is required"/>
                    </FormFeedback>
                    }

                    {showError() &&
                    <FormFeedback>
                        {getErrorMessage()}
                    </FormFeedback>
                    }
                </InputGroup>
            </FormGroup>
        )
    }
}

export default withFormsy(PhoneInputFormGroup);


// WEBPACK FOOTER //
// ./src/components/Form/PhoneInputFormGroup.jsx